import { makeStyles } from '@mui/styles'
import {
  ALICE_BLUE,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  SILVER_SAND,
  SOLITUDE,
} from '@returnmates/client-core/src/constants/colors'

import { INTER, POPPINS } from '../../constants/styles/fonts'

interface Props {
  isTaskTypeFilterEnabled?: boolean
}

const useStyles = makeStyles(() => ({
  calendarWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    zIndex: 102,
  },
  tooltip: {
    fontFamily: POPPINS,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '160%',
    color: '#FFFFFF',
    backgroundColor: 'rgba(102, 109, 120, 0.94)',
    marginTop: 15,
  },
  iconButton: {
    padding: 0,
    margin: '0 10px',
    pointerEvents: ({ isTaskTypeFilterEnabled }: Props) =>
      isTaskTypeFilterEnabled ? 'auto' : 'none',
  },
  calendarIcon: {
    width: 18,
    height: 18,
  },
  modalButtons: {
    display: 'flex',
    margin: '0 25px 20px',
  },
  toolbarDatePicker: {
    position: 'absolute',
    left: '-150px',
    top: 10,
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    zIndex: 1,
    border: `1px solid ${SILVER_SAND}`,
    borderRadius: 3,
    animation: `$fadeInDown 0.3s ease-out`,
    boxShadow: '3px 4px 4px 0px #00000040',
  },
  button: {
    textTransform: 'capitalize',
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '130%',
    borderRadius: '4px',
    padding: '10px 0',
    width: '130px',
  },
  cancelButton: {
    marginRight: '10px',
    marginLeft: 'auto',
    backgroundColor: ALICE_BLUE,
    border: `1px solid ${SOLITUDE}`,
    color: MIDNIGHT_EXPRESS,
    '&:hover': {
      backgroundColor: ALICE_BLUE,
    },
  },
  applyButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    border: `1px solid ${NEON_BLUE_LIGHT}`,
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
    },
  },
  scheduleContainer: {
    margin: '-35px 25px 10px',
  },
  scheduleText: {
    fontSize: 12,
    fontFamily: INTER,
    fontWeight: 400,
  },
  hidden: {
    visibility: 'hidden',
  },
  notes: {
    fontSize: 14,
    fontFamily: INTER,
    fontWeight: 800,
    margin: '10px 25px',
  },
}))

export default useStyles
